import {
  AUTH_LOGIN,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILED,
  AUTH_LOGIN_REQUIRES_2FA,
  AUTH_LOGIN_NEW_PASSWORD_REQUIRED,
  AUTH_LOGIN_TOTP_REQUIRED,
  AUTH_2FA_VERIFY_SUCCESS,
  AUTH_2FA_VERIFY_FAILED,
  AUTH_GET_WORKSPACES_SUCCESS,
  AUTH_GET_WORKSPACES_FAILED,
  AUTH_CHANGE_WORKSPACE_SUCCESS,
  AUTH_CHANGE_WORKSPACE_FAILED,
  AUTH_MANAGE_NOTIFICATIONS_SUCCESS,
  AUTH_MANAGE_NOTIFICATIONS_FAILED
} from './types';
import { CLEAR_SESSION } from '../../session/types';

const initialState = {
  current: {
    user: null,
    workspaces: null
  },
  twoFactor: {
    required: false,
    accountId: null,
    email: null
  },
  newPasswordChallenge: {
    required: false,
    email: null,
    userAttributes: null
  },
  cognitoTotpChallenge: {
    required: false,
    email: null,
    challengeName: null
  }
};

export default function loginReducer(state = initialState, action = {}) {
  switch (action.type) {
    case AUTH_LOGIN:
      // Reset transient errors / challenges when the user starts a fresh attempt.
      return {
        ...state,
        error: null,
        twoFactor: { required: false, accountId: null, email: null },
        newPasswordChallenge: { required: false, email: null, userAttributes: null },
        cognitoTotpChallenge: { required: false, email: null, challengeName: null }
      };
    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          user: action.payload.user
        },
        twoFactor: {
          required: false,
          accountId: null,
          email: null
        },
        newPasswordChallenge: {
          required: false,
          email: null,
          userAttributes: null
        },
        cognitoTotpChallenge: {
          required: false,
          email: null,
          challengeName: null
        },
        error: null
      }
    case AUTH_LOGIN_FAILED:
      return {
        ...state,
        error: action.payload,
        twoFactor: {
          required: false,
          accountId: null,
          email: null
        }
      };
    case AUTH_LOGIN_NEW_PASSWORD_REQUIRED:
      return {
        ...state,
        newPasswordChallenge: {
          required: true,
          email: action.payload.email,
          userAttributes: action.payload.userAttributes
        },
        error: null
      };
    case AUTH_LOGIN_TOTP_REQUIRED:
      return {
        ...state,
        cognitoTotpChallenge: {
          required: true,
          email: action.payload.email || state.cognitoTotpChallenge?.email || null,
          challengeName: action.payload.challengeName
        },
        newPasswordChallenge: { required: false, email: null, userAttributes: null },
        error: null
      };
    case AUTH_LOGIN_REQUIRES_2FA:
      return {
        ...state,
        twoFactor: {
          required: true,
          accountId: action.payload.accountId,
          email: action.payload.email
        },
        error: null
      };
    case AUTH_2FA_VERIFY_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          user: action.payload.user
        },
        twoFactor: {
          required: false,
          accountId: null,
          email: null
        },
        error: null
      }
    case AUTH_2FA_VERIFY_FAILED:
      return {
        ...state,
        error: action.payload
      };
    case AUTH_GET_WORKSPACES_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          workspaces: action.payload
        }
      };
    case AUTH_GET_WORKSPACES_FAILED:
      return {
        ...state,
        error: action.payload
      };
    case AUTH_CHANGE_WORKSPACE_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          user: action.payload.user
        }
      }
    case AUTH_CHANGE_WORKSPACE_FAILED:
      return {
        ...state,
        error: action.payload
      };
    case AUTH_MANAGE_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          user: action.payload
        }
      }
    case AUTH_MANAGE_NOTIFICATIONS_FAILED:
      return {
        ...state,
        error: action.payload
      };
    case CLEAR_SESSION:
      return initialState;
    default:
      break;
  }
  return state;
}